import React, { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { adminRoutes, clientRoutes } from 'configs/routes';

const MainLayout: FC = () => {
  const isLogged = false;
  const renderComponent = (
    isLogged: boolean,
    module: any,
    isPrivate: boolean,
  ) => {
    if (isPrivate) {
      return isLogged ? module : <Navigate to="/login" />;
    }
    return module;
  };
  return (
    <Routes>
      {clientRoutes.map((val, index) => (
        <Route key={index} element={val.module} path={val.path} />
      ))}
      {
        <Route
          path={adminRoutes.path}
          element={renderComponent(
            isLogged,
            adminRoutes.module,
            adminRoutes.isPrivate,
          )}
        >
          {adminRoutes.children.map((val, index) => (
            <Route
              index={!val.path}
              key={index}
              path={val.path}
              element={val.module}
            />
          ))}
        </Route>
      }
    </Routes>
  );
};

export default MainLayout;
